var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.$auth.loading)?_c('div',[_c('div',{staticClass:"home"},[_c('Attendance')],1)]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }